module.exports = __webpack_public_path__ + "static/media/intro-banner-image.10662c4a.jpg";